import WithHint from './WithHint.vue';
import Icon from './Icon';
import CustomHeader from './CustomHeader.vue';

export default {
  Icon,
  WithHint,
  CustomHeader,
};
